module.exports = __webpack_public_path__ + "static/media/bowen-42.59138d06.jpg";